import React from "react";
const initialContext = {
  access_token: localStorage.getItem("access_token"),
  user: localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user") ?? "")
    : null,
} as any;
export const MainContext = React.createContext(initialContext);
